import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Globe, HelpCircle, User } from 'lucide-react';
export function TopBar() {
  return <div className="w-full bg-white border-b border-gray-100 text-[11px] font-medium uppercase tracking-wider text-gray-600 hidden lg:block" data-id="element-161">
      <div className="max-w-[1440px] mx-auto flex justify-between items-stretch h-10" data-id="element-162">
        <div className="flex items-center px-6 border-r border-gray-100" data-id="element-163">
          <a href="tel:+1234567890" className="flex items-center gap-2 hover:text-black transition-colors" data-id="element-164">
            <Phone size={14} data-id="element-165" />
            <span data-id="element-166">+1 (234) 567-890</span>
          </a>
        </div>

        <div className="flex items-stretch" data-id="element-167">
          <div className="flex items-center px-6 border-l border-gray-100 cursor-pointer hover:bg-gray-50 transition-colors" data-id="element-168">
            <span className="flex items-center gap-2" data-id="element-169">
              English <Globe size={14} data-id="element-170" />
            </span>
          </div>
          <div className="flex items-center px-6 border-l border-gray-100 cursor-pointer hover:bg-gray-50 transition-colors" data-id="element-171">
            <span className="flex items-center gap-2" data-id="element-172">
              <HelpCircle size={14} data-id="element-173" /> FAQ
            </span>
          </div>
          <div className="flex items-center px-6 border-l border-gray-100 cursor-pointer hover:bg-gray-50 transition-colors" data-id="element-174">
            <span className="flex items-center gap-2" data-id="element-175">
              <User size={14} data-id="element-176" /> My Account
            </span>
          </div>
          <Link to="/contact" className="flex items-center px-8 bg-[#b22222] text-white hover:bg-[#8b0000] transition-colors font-bold" data-id="element-177">
            Book a Consultation
          </Link>
        </div>
      </div>
    </div>;
}